var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.75C10.5 4.33579 10.1642 4 9.75 4C9.33579 4 9 4.33579 9 4.75V9H4.75C4.33579 9 4 9.33579 4 9.75C4 10.1642 4.33579 10.5 4.75 10.5H9V14.75C9 15.1642 9.33579 15.5 9.75 15.5C10.1642 15.5 10.5 15.1642 10.5 14.75V10.5H14.75C15.1642 10.5 15.5 10.1642 15.5 9.75C15.5 9.33579 15.1642 9 14.75 9H10.5V4.75Z",
    fill: "#0E0E0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.2c0ef70e1f531b56878bfae729026d16.svg";
export { ForwardRef as ReactComponent };